var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.object.profile != null
    ? _c(
        "span",
        { staticClass: "renderer" },
        [
          _c(
            "router-link",
            {
              staticClass: "d-inline-flex align-items-center",
              attrs: {
                to: "/configurations/profiles/" + _vm.object.profile.id,
              },
            },
            [
              _c("ProfileIcon", {
                staticClass: "mr-2",
                staticStyle: { "font-size": "0.9em" },
                attrs: { icon: _vm.object.profile.icon },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.object.profile.name)),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }